// Pahar — Mandala launch sections.
//
// Product cards: an image carousel, and a "+" that opens a size row. Picking
// a size posts to /cart/add.js and opens Dawn's cart drawer in the same round
// trip, the same way pahar-shop.js and Dawn's own product form do.
// Collection page: the sort select reloads with ?sort_by=.

(function () {
  'use strict';

  var ADD_URL = (window.routes && window.routes.cart_add_url) || '/cart/add';

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.querySelector('.pahar-header__cart-count');
        if (!badge) return;
        badge.textContent = cart.item_count;
        badge.toggleAttribute('hidden', cart.item_count === 0);
      })
      .catch(function () {});
  }

  function initCarousel(card) {
    var track = card.querySelector('.mx-card__track');
    if (!track) return;
    var dots = card.querySelectorAll('.mx-card__dots i');
    var n = track.children.length;
    var i = 0;
    function go(to) {
      i = (to + n) % n;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      card.dataset.slide = i; // the hover photo only shows on the first slide
      for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === i);
    }
    var prev = card.querySelector('.mx-card__arrow--prev');
    var next = card.querySelector('.mx-card__arrow--next');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    // Swipe on touch; a swipe must not also follow the image's link.
    var x0 = null;
    var swiped = false;
    track.addEventListener('pointerdown', function (e) { x0 = e.clientX; swiped = false; });
    track.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) { swiped = true; go(i + (dx < 0 ? 1 : -1)); }
    });
    track.addEventListener('click', function (e) { if (swiped) { e.preventDefault(); swiped = false; } });
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    go(0);
  }

  function initQuickAdd(card) {
    var plus = card.querySelector('.mx-card__plus');
    if (!plus) return;
    var msg = card.querySelector('.mx-card__msg');
    var media = card.querySelector('.mx-card__media');

    function setOpen(open) {
      card.classList.toggle('is-open', open);
      plus.setAttribute('aria-expanded', String(open));
    }
    function say(text) { if (msg) msg.textContent = text || ''; }

    plus.addEventListener('click', function () {
      var open = !card.classList.contains('is-open');
      setOpen(open);
      say('');
      var first = card.querySelector('.mx-card__sizes button:not([disabled])');
      if (open && first) first.focus({ preventScroll: true });
    });

    // The media box clips its overflow; never let focus scroll it.
    if (media) media.addEventListener('scroll', function () { media.scrollTop = 0; media.scrollLeft = 0; });

    card.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && card.classList.contains('is-open')) {
        setOpen(false);
        plus.focus();
      }
    });

    var buttons = card.querySelectorAll('.mx-card__sizes button[data-variant-id]');
    for (var b = 0; b < buttons.length; b++) {
      buttons[b].addEventListener('click', function (event) {
        var button = event.currentTarget;
        var cartDrawer = document.querySelector('cart-drawer');
        var body = { items: [{ id: Number(button.getAttribute('data-variant-id')), quantity: 1 }] };
        if (cartDrawer && cartDrawer.getSectionsToRender) {
          body.sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
          body.sections_url = window.location.pathname;
          cartDrawer.setActiveElement(plus);
        }
        card.classList.add('is-adding');
        say('');
        fetch(ADD_URL + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.status) {
              say(data.description || data.message || 'Could not add that size');
              return;
            }
            setOpen(false);
            if (cartDrawer && data.sections) {
              // A drawer rendered for an empty cart carries .is-empty, which
              // hides the item list. Dawn's product form clears it first; so must we.
              cartDrawer.classList.remove('is-empty');
              cartDrawer.renderContents(data);
            } else {
              say('Added to bag');
            }
            refreshCartCount();
            document.dispatchEvent(new CustomEvent('pahar:added'));
          })
          .catch(function () { say('Something went wrong, try again'); })
          .then(function () { card.classList.remove('is-adding'); });
      });
    }
  }

  function initSort() {
    var select = document.querySelector('[data-mx-sort]');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  function boot() {
    var cards = document.querySelectorAll('.mx-card');
    for (var c = 0; c < cards.length; c++) {
      initCarousel(cards[c]);
      initQuickAdd(cards[c]);
    }
    initSort();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
